import React from 'react';
import PropTypes from 'prop-types';
import Card from '../card/card';

export default function FeaturedStory(props) {
  const { story, fullPageAdvertorial } = props;

  return (
    <div className="featured-story">
      <Card
        metadata={story}
        rowCardCount={1}
        bigStory={true}
        className="featured-story__card-wrapper big-card"
        fullPageAdvertorial={fullPageAdvertorial}
      />
    </div>
  );
}

FeaturedStory.defaultProps = {
  fullPageAdvertorial: false
};

FeaturedStory.propTypes = {
  story: PropTypes.shape({}).isRequired,
  fullPageAdvertorial: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/featured_story/featured_story.js